import { Layout } from 'antd';
import React, { useEffect } from 'react';
import Header from '../Components/AdminHeader';

function AdminLayout({ element }) {
    useEffect(() => {
        window.scrollTo(0, 0);
    });
    return (
        <Layout>
            <Header />
            <Layout className="main">
                <Layout.Content className="main-content">
                    {element}
                </Layout.Content>
            </Layout>
        </Layout>
    );
}

export default AdminLayout;
